import { style } from 'typestyle'
export const mb16 = style({ marginBottom: '16px' })
